module.exports = __webpack_public_path__ + "static/media/icon-up-red.34b1079b.svg";